exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FloatingBarLayout_root_39EBk {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.FloatingBarLayout_bar_1kbuD {\n  z-index: 1;\n  pointer-events: none;\n  flex: 0 1 auto;\n}\n\n.FloatingBarLayout_barContent_tgN9C {\n  margin: 0 auto;\n  pointer-events: auto;\n}\n\n.FloatingBarLayout_floating_4fL-r {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 16px;\n}\n\n.FloatingBarLayout_floatingTop_1WPdL {\n  top: 0;\n}\n\n.FloatingBarLayout_floatingBottom_1URWB {\n  bottom: 0;\n}\n\n.FloatingBarLayout_body_2zjku {\n  flex: 1 1 auto;\n  position: relative;\n}\n\n.FloatingBarLayout_bodyContent_2OV8q {\n  height: 100%;\n  position: absolute;\n  top: 0; right: 0; bottom: 0; left: 0;\n}\n", ""]);

// exports
exports.locals = {
	"root": "FloatingBarLayout_root_39EBk",
	"bar": "FloatingBarLayout_bar_1kbuD",
	"barContent": "FloatingBarLayout_barContent_tgN9C",
	"floating": "FloatingBarLayout_floating_4fL-r",
	"floatingTop": "FloatingBarLayout_floatingTop_1WPdL",
	"floatingBottom": "FloatingBarLayout_floatingBottom_1URWB",
	"body": "FloatingBarLayout_body_2zjku",
	"bodyContent": "FloatingBarLayout_bodyContent_2OV8q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/FloatingBarLayout/FloatingBarLayout.css
// module id = 1206
// module chunks = 2